import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpring = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 93,
	viewBox: "0 0 65 93",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_43_163)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M31.44 77.18C31.44 77.18 23.72 60.31 9.71997 59.59C9.71997 59.59 6.72997 74.79 31.44 77.18Z",
				fill: "url(#paint0_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.58 76.91C30.58 76.91 38.3 60.04 52.3 59.32C52.3 59.32 55.29 74.52 30.58 76.91Z",
				fill: "url(#paint1_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.34 90.6C17.16 64.82 30.49 44.53 30.57 44.13L32.17 44.48C32.09 44.87 18.95 64.36 41.55 89.5L40.3301 90.6H40.34Z",
				fill: "url(#paint2_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.42 16.89C24.1 24.3 28.17 29.69 31.5 28.94C34.83 28.18 36.16 21.56 34.48 14.15C32.8 6.74001 28.73 1.35001 25.4 2.10001C22.07 2.86001 20.74 9.48001 22.42 16.89Z",
				fill: "url(#paint3_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.66 48.72C31.34 56.13 35.41 61.52 38.74 60.77C42.07 60.01 43.4 53.39 41.72 45.98C40.04 38.57 35.97 33.18 32.64 33.93C29.31 34.69 27.98 41.31 29.66 48.72Z",
				fill: "url(#paint4_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.7 14.06C30.36 20.88 30.13 27.63 33.2 29.14C36.27 30.64 41.46 26.33 44.81 19.5C48.15 12.68 48.38 5.93001 45.31 4.42001C42.24 2.92001 37.05 7.23001 33.7 14.06Z",
				fill: "url(#paint5_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.34 43.37C16 50.19 15.77 56.94 18.84 58.45C21.91 59.95 27.1 55.64 30.45 48.81C33.79 41.99 34.02 35.24 30.95 33.73C27.88 32.23 22.69 36.54 19.34 43.37Z",
				fill: "url(#paint6_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.28 18.05C36.65 21.77 32.63 27.2 34.31 30.18C35.98 33.16 42.71 32.56 49.34 28.84C55.97 25.12 59.99 19.69 58.31 16.71C56.64 13.73 49.91 14.33 43.28 18.05Z",
				fill: "url(#paint7_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.81 34.03C8.18003 37.75 4.16003 43.18 5.84003 46.16C7.51003 49.14 14.24 48.54 20.87 44.82C27.5 41.1 31.52 35.67 29.84 32.69C28.17 29.71 21.44 30.31 14.81 34.03Z",
				fill: "url(#paint8_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.7 26.15C41.11 25.74 34.81 28.17 34.62 31.57C34.43 34.98 40.44 38.08 48.02 38.49C55.61 38.9 61.91 36.47 62.1 33.07C62.29 29.66 56.28 26.56 48.7 26.15Z",
				fill: "url(#paint9_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.11 24.37C8.52002 23.96 2.22002 26.39 2.03002 29.79C1.84002 33.2 7.85002 36.3 15.43 36.71C23.02 37.12 29.32 34.69 29.51 31.29C29.7 27.88 23.69 24.78 16.11 24.37Z",
				fill: "url(#paint10_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.59 37.05C42.73 32.21 36.21 30.43 34.04 33.06C31.87 35.69 34.86 41.75 40.72 46.59C46.58 51.43 53.1 53.21 55.27 50.58C57.44 47.95 54.45 41.89 48.59 37.05Z",
				fill: "url(#paint11_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.41 16.28C17.55 11.44 11.03 9.66003 8.85996 12.29C6.68996 14.92 9.67996 20.98 15.54 25.82C21.4 30.66 27.92 32.44 30.09 29.81C32.26 27.18 29.27 21.12 23.41 16.28Z",
				fill: "url(#paint12_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.72 28.37C43.13 21.36 36.15 16.97 29.14 18.56C22.13 20.15 17.74 27.13 19.33 34.14C20.92 41.15 27.9 45.54 34.91 43.95C41.92 42.36 46.31 35.38 44.72 28.37Z",
				fill: "url(#paint13_linear_43_163)",
				stroke: "white",
				strokeWidth: 4.06,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.44 77.18C31.44 77.18 23.72 60.31 9.71997 59.59C9.71997 59.59 6.72997 74.79 31.44 77.18Z",
				fill: "url(#paint14_linear_43_163)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.58 76.91C30.58 76.91 38.3 60.0399 52.3 59.3199C52.3 59.3199 55.29 74.5199 30.58 76.91Z",
				fill: "url(#paint15_linear_43_163)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.34 90.6C17.16 64.82 30.49 44.53 30.57 44.13L32.17 44.48C32.09 44.87 18.95 64.36 41.55 89.5L40.3301 90.6H40.34Z",
				fill: "url(#paint16_linear_43_163)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M62.11 33.07C62.26 30.29 58.29 27.71 52.7 26.63C57.24 23.2 59.66 19.13 58.3 16.71C56.86 14.14 51.65 14.24 45.99 16.71C48.13 10.92 47.94 5.71998 45.3 4.41998C42.39 2.98998 37.55 6.81998 34.21 13.06C32.39 6.21998 28.57 1.37998 25.4 2.09998C22.32 2.79998 20.95 8.52998 22.1 15.26C16.61 11.21 10.88 9.84998 8.85999 12.29C6.89999 14.66 9.13999 19.8 13.88 24.33C7.31999 24.45 2.18999 26.72 2.02999 29.79C1.87999 32.57 5.84999 35.15 11.44 36.22C6.89999 39.65 4.47999 43.72 5.83999 46.14C7.27999 48.71 12.49 48.61 18.15 46.14C16.01 51.93 16.2 57.13 18.84 58.43C21.75 59.86 26.59 56.03 29.93 49.79C31.75 56.63 35.58 61.47 38.74 60.75C41.82 60.05 43.19 54.32 42.04 47.59C47.53 51.64 53.26 53 55.28 50.56C57.24 48.19 55 43.05 50.26 38.52C56.82 38.4 61.95 36.13 62.11 33.06V33.07ZM32.64 33.93C32.32 34 32.01 34.14 31.72 34.32C31.49 34.09 31.23 33.88 30.94 33.74C30.68 33.61 30.41 33.53 30.13 33.49C30.07 33.21 29.97 32.94 29.83 32.7C29.7 32.47 29.53 32.27 29.35 32.09C29.44 31.84 29.49 31.58 29.51 31.31C29.53 31 29.49 30.7 29.41 30.4C29.66 30.24 29.9 30.05 30.09 29.82C30.29 29.58 30.43 29.3 30.54 29.01C30.86 29.04 31.18 29.03 31.49 28.96C31.81 28.89 32.12 28.75 32.41 28.57C32.64 28.8 32.9 29.01 33.19 29.15C33.45 29.28 33.72 29.36 34 29.4C34.06 29.68 34.16 29.95 34.3 30.19C34.43 30.42 34.6 30.62 34.78 30.8C34.69 31.05 34.64 31.31 34.62 31.58C34.6 31.89 34.64 32.19 34.72 32.49C34.47 32.65 34.23 32.84 34.04 33.07C33.84 33.31 33.7 33.59 33.59 33.88C33.27 33.85 32.95 33.86 32.64 33.93Z",
				fill: "url(#paint17_radial_43_163)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.72 28.37C43.13 21.36 36.15 16.97 29.14 18.56C22.13 20.15 17.74 27.13 19.33 34.14C20.92 41.15 27.9 45.54 34.91 43.95C41.92 42.36 46.31 35.38 44.72 28.37Z",
				fill: "url(#paint18_linear_43_163)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_43_163",
			x1: 3.56997,
			y1: 94.16,
			x2: 37.24,
			y2: 43.15,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .33,
					stopColor: "#426B52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .41,
					stopColor: "#456D52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .48,
					stopColor: "#4F7653"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .54,
					stopColor: "#608455"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#789858"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .65,
					stopColor: "#9AB55C"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_43_163",
			x1: 58.45,
			y1: 93.89,
			x2: 24.7799,
			y2: 42.88,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .33,
					stopColor: "#426B52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .41,
					stopColor: "#456D52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .48,
					stopColor: "#4F7653"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .54,
					stopColor: "#608455"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#789858"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .65,
					stopColor: "#9AB55C"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_43_163",
			x1: 28.94,
			y1: 34.87,
			x2: 39.66,
			y2: 119.35,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .14,
					stopColor: "#426B52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .36,
					stopColor: "#446D52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .51,
					stopColor: "#4E7553"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .65,
					stopColor: "#5D8255"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .77,
					stopColor: "#749557"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .88,
					stopColor: "#90AD5A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .92,
					stopColor: "#9AB55C"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_43_163",
			x1: 31.6009,
			y1: 29.4174,
			x2: 13.7703,
			y2: -49.001,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_43_163",
			x1: 38.828,
			y1: 61.2473,
			x2: 20.9996,
			y2: -17.1614,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_43_163",
			x1: 33.116,
			y1: 29.5952,
			x2: 68.4959,
			y2: -42.6242,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint6_linear_43_163",
			x1: 18.7564,
			y1: 58.9068,
			x2: 54.1319,
			y2: -13.3036,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint7_linear_43_163",
			x1: 33.9298,
			y1: 30.2735,
			x2: 104.053,
			y2: -9.0777,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint8_linear_43_163",
			x1: 5.45676,
			y1: 46.2519,
			x2: 75.5886,
			y2: 6.89578,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint9_linear_43_163",
			x1: 33.9064,
			y1: 31.5299,
			x2: 114.207,
			y2: 35.907,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint10_linear_43_163",
			x1: 1.31483,
			y1: 29.7534,
			x2: 81.6056,
			y2: 34.1299,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint11_linear_43_163",
			x1: 34.0595,
			y1: 32.8918,
			x2: 96.0957,
			y2: 84.0669,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint12_linear_43_163",
			x1: 8.88086,
			y1: 12.1214,
			x2: 70.9093,
			y2: 63.2902,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .76,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint13_linear_43_163",
			x1: 35.0064,
			y1: 44.3951,
			x2: 18.1425,
			y2: -29.7718,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .18,
					stopColor: "#40201C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .55,
					stopColor: "#633328"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .92,
					stopColor: "#8B4A37"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint14_linear_43_163",
			x1: 3.56997,
			y1: 94.16,
			x2: 37.24,
			y2: 43.15,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .33,
					stopColor: "#426B52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .41,
					stopColor: "#456D52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .48,
					stopColor: "#4F7653"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .54,
					stopColor: "#608455"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#789858"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .65,
					stopColor: "#9AB55C"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint15_linear_43_163",
			x1: 58.45,
			y1: 93.89,
			x2: 24.7799,
			y2: 42.88,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .33,
					stopColor: "#426B52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .41,
					stopColor: "#456D52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .48,
					stopColor: "#4F7653"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .54,
					stopColor: "#608455"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#789858"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .65,
					stopColor: "#9AB55C"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint16_linear_43_163",
			x1: 28.94,
			y1: 34.87,
			x2: 39.66,
			y2: 119.35,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .14,
					stopColor: "#426B52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .36,
					stopColor: "#446D52"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .51,
					stopColor: "#4E7553"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .65,
					stopColor: "#5D8255"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .77,
					stopColor: "#749557"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .88,
					stopColor: "#90AD5A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .92,
					stopColor: "#9AB55C"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint17_radial_43_163",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(32.07 31.43) scale(29.73 29.73)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#F6CC66"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .85,
					stopColor: "#E19159"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D87854"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint18_linear_43_163",
			x1: 35.0064,
			y1: 44.3951,
			x2: 18.1425,
			y2: -29.7718,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .18,
					stopColor: "#40201C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .55,
					stopColor: "#633328"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .92,
					stopColor: "#8B4A37"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_43_163",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 64.14,
				height: 92.63,
				fill: "white"
			})
		})
	] })]
});
export default SvgSpring;
